import { ROLES } from "constants/index";

/**
 * Role-based navigation list — single source of truth.
 *
 * Consumed by:
 *  - Desktop header nav (NavigationLink uses `displayAsSelected`)
 *  - Mobile full-page menu (/menu — ignores `displayAsSelected`)
 *
 * Reports gating: the Reports feature is still in development; data accuracy
 * is being validated against the source of truth before exposure to customer
 * accounts. We hide the nav entry on the production domain
 * (app.centralvaluations.ie) but show it on dev (dev.centralvaluations.ie)
 * and local development. Vercel sets `VERCEL_ENV=production` for deploys
 * triggered from the production branch (main → app), and `preview` for
 * everything else (dev branch → dev.centralvaluations.ie).
 *
 * Originally hidden via commenting in components/Header/Header.js (commit
 * 84224c4e). When the nav was extracted to this helper, the guard moved
 * here.
 *
 * @param {string} role - Effective user role from UserInfoContext
 * @returns {Array<{ name: string, url: string, displayAsSelected?: string }>}
 */

const isProductionDeploy = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";
const REPORTS_NAV = isProductionDeploy
  ? []
  : [{ name: "Reports", url: "/reports" }];

export const generateNavList = (role) => {
  switch (role) {
    case ROLES.SUPER_ADMIN:
      return [
        { name: "Valuations", url: "/valuation/list", displayAsSelected: "/valuation" },
        { name: "Banks", url: "/bank/list", displayAsSelected: "/bank" },
        { name: "Organisations", url: "/organisation/list", displayAsSelected: "/organisation" },
        { name: "Companies", url: "/company/list" },
        { name: "Billing", url: "/admin/billing" },
        ...REPORTS_NAV,
        { name: "Settings", url: "/profile/settings", displayAsSelected: "/profile" },
      ];

    case ROLES.BANK_ADMIN:
    case ROLES.BANK_USER:
      return [
        { name: "Valuations", url: "/valuation/list", displayAsSelected: "/valuation" },
        { name: "Panel of Valuers", url: "/panel_of_valuers" },
        ...REPORTS_NAV,
        { name: "Settings", url: "/profile/settings", displayAsSelected: "/profile" },
      ];

    case ROLES.ORGANISATION_ADMIN:
    case ROLES.ORGANISATION_USER:
      return [
        { name: "Valuations", url: "/valuation/list", displayAsSelected: "/valuation" },
        { name: "Companies", url: "/company/list", displayAsSelected: "/company" },
        ...REPORTS_NAV,
        { name: "Settings", url: "/profile/settings", displayAsSelected: "/profile" },
      ];

    case ROLES.COMPANY_ADMIN:
    case ROLES.COMPANY_USER:
      return [
        { name: "Valuations", url: "/valuation/list", displayAsSelected: "/valuation" },
        ...REPORTS_NAV,
        { name: "Settings", url: "/profile/settings", displayAsSelected: "/profile" },
      ];

    default:
      return [];
  }
};
